import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import DiffTestComponent from "./DiffTestComponent";
import "./lib/mergely.css";
import "./lib/mergely.min.js";

const DiffComponent = () => {
  const [json1, setJson1] = useState(`{
  "company": "SFDC247",
  "employees": [
    { "id": 1, "name": "John Doe", "role": "Salesforce Developer" }
  ]
}`);
  const [json2, setJson2] = useState(`{
  "company": "SFDC247",
  "employees": [
    { "id": 2, "name": "Jane Smith", "role": "Salesforce Architect" }
  ]
}`);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const validateJSON = (json) => {
    try {
      JSON.parse(json);
      return true;
    } catch {
      return false;
    }
  };

  const handleCompare = () => {
    if (!validateJSON(json1) || !validateJSON(json2)) {
      setError("Invalid JSON input. Please correct the JSON and try again.");
      return;
    }
    setError("");
    setIsPopupOpen(true);
  };

  const handleClear = () => {
    setJson1("");
    setJson2("");
    setError("");
  };

  const handleFileUpload = (event, setJson) => {
    const file = event.target.files[0];
    if (!file) return;
    setLoading(true);
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const content = e.target.result;
        JSON.parse(content);
        setJson(content);
        setError("");
      } catch {
        setError("Invalid JSON file. Please upload a valid JSON.");
      } finally {
        setLoading(false);
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <label>
            <input type="checkbox" style={{ marginRight: "5px" }} />
            Wrap Lines
          </label>
          <label style={{ marginLeft: "10px" }}>
            <input type="checkbox" style={{ marginRight: "5px" }} />
            Show Line Numbers
          </label>
        </div>
        <div>
          <button
            className="btn btn-info me-2"
            onClick={() => setJson1(`{ "company": "SFDC247" }`)}
          >
            Use Example Data
          </button>
          <button className="btn btn-secondary" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="row">
        <div className="col-md-6">
          <textarea
            className="form-control"
            rows="10"
            value={json1}
            onChange={(e) => setJson1(e.target.value)}
          />
          <input
            type="file"
            accept=".json"
            onChange={(e) => handleFileUpload(e, setJson1)}
          />
        </div>
        <div className="col-md-6">
          <textarea
            className="form-control"
            rows="10"
            value={json2}
            onChange={(e) => setJson2(e.target.value)}
          />
          <input
            type="file"
            accept=".json"
            onChange={(e) => handleFileUpload(e, setJson2)}
          />
        </div>
      </div>

      {loading && <ClipLoader size={30} />}

      <div className="text-center mt-3">
        <button className="btn btn-success" onClick={handleCompare}>
          Compare JSON
        </button>
      </div>

      {isPopupOpen && (
        <DiffTestComponent
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          json1={json1}
          json2={json2}
        />
      )}
    </div>
  );
};

export default DiffComponent;